import Swiper from 'swiper';

export default function() {
    let mainSwiper = new Swiper('.js-main-slider', {
        loop: true,
        effect: 'fade',
        speed: 700,
        fadeEffect: { crossFade: true },
        pagination: {
            el: '.js-main-slider .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.main-slider__arrow-next',
            prevEl: '.main-slider__arrow-prev',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
    });


    $(".js-main-slider").hover(function(){
        mainSwiper.autoplay.stop();
    }, function(){
        mainSwiper.autoplay.start();
    });
}
